<template>
  <div>
    <div>
      <div :style="!loadingWorkshopData && workshopFeatureData.workshops_title.content_background_color ? getDynamicPageBg(workshopFeatureData.workshops_title) : ''" class="py-3">
        <div class="container">
          <div class="d-flex justify-content-end">
            <ol class="breadcrumb text-align-right">
              <li class="breadcrumb-item flex-grow-1"><a href="/">Home</a></li>
              <li class="breadcrumb-item active">Workshops</li>
            </ol>
          </div>
        </div>
      </div>

      <scientific-activities-custom-static-content
        :dataLoading="loadingWorkshopData"
        :title=" !loadingWorkshopData ? (workshopType === 'past' ? workshopFeatureData.past_workshops_title : workshopFeatureData.workshops_title): {}"
        :photos=" !loadingWorkshopData ? (workshopType === 'past'  ? workshopFeatureData.past_workshops_photo.value : workshopFeatureData.workshops_photo.value): []"
        :description=" !loadingWorkshopData ? (workshopType === 'past'  ? workshopFeatureData.past_workshops_text.value : workshopFeatureData.workshops_text.value): ''"
        :edit-cms-route="  !loadingWorkshopData ? (workshopType === 'past'  ? 'past-workshops-edit' : 'workshops-edit'): ''"
        :menu-id="!loadingWorkshopData ? menuId: 0 "
      />
      <custom-dynamic-static-content-page :new-contents="newContents"/>
    </div>
    <div id="workshop-tab-id" v-if="!loadingWorkshopData">
      <div class="container pt-dtl-tab-bg">
        <div class="custom-tab">
          <div>
            <b-tabs card lazy>
              <div v-if="this.workshopType !== 'past'">
                <b-tab
                  title="Current and Upcoming"
                  @click.prevent="setCurrentTab('current_upcoming_workshop', 'workshop-tab-id')"
                  :active="getActiveTab === 'current_upcoming_workshop'"
                >
                  <current-and-upcoming-workshop-tab :workshop-type="workshopType" />
                </b-tab>
                <b-tab
                  title="Programmatic"
                  @click.prevent="setCurrentTab('programmatic_workshop', 'workshop-tab-id')"
                  :active="getActiveTab === 'programmatic_workshop'"
                >
                  <programmatic-tab :workshop-type="workshopType" />
                </b-tab>
                <b-tab
                  title="Hot Topics"
                  @click.prevent="setCurrentTab('hot_topics_workshop', 'workshop-tab-id')"
                  :active="getActiveTab === 'hot_topics_workshop'"
                >
                  <topic-tab :workshop-type="workshopType" />
                </b-tab>
                <b-tab
                  title="Revisiting Fundamental Problems"
                  @click.prevent="setCurrentTab('revisiting_fundamental_problems', 'workshop-tab-id')"
                  :active="getActiveTab === 'revisiting_fundamental_problems'"
                >
                  <cold-topic-tab :workshop-type="workshopType" />
                </b-tab>
                <b-tab
                  title="Critical Issues in Math Education"
                  @click.prevent="setCurrentTab('critical_issues_workshop', 'workshop-tab-id')"
                  :active="getActiveTab === 'critical_issues_workshop'"
                >
                  <critical-issue-workshop-tab :workshop-type="workshopType" />
                </b-tab>
                <b-tab
                  title="Other Workshops"
                  @click.prevent="setCurrentTab('other_workshop', 'workshop-tab-id')"
                  :active="getActiveTab === 'other_workshop'"
                >
                  <other-workshop-tab :workshop-type="workshopType" />
                </b-tab>
              </div>
              <b-tab
                title="Past Workshops"
                @click.prevent="setCurrentTab('past_workshop', 'workshop-tab-id')"
                :active="getActiveTab === 'past_workshop'"
              >
                <past-workshop-tab :workshop-type="workshopType" />
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

  <!-- <div class="primary-background">
    <div class="container pt-xlg pb-xlg">
      <div>
        <div class="col-md-12 col-lg-8 col-xl-7 text-center p-0 mx-auto">
          <h1 class="display-4 mb-2 medium-32">
            Looking for Past Workshops?
          </h1>
          <div class="regular-16 mb-5">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididnut
            ut labore et dolore magna aliqua.
          </div>
          <div class="w-50">
              <span v-for="(year, index) in programData.years" :key="index">
          <span class="typo-color-blue">{{ year }}</span>
          </span>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  </div>
</template>

<script>
import CurrentAndUpcomingWorkshopTab from './CurrentAndUpcomingWorkshopTab.vue'
import PastWorkshopTab from './PastWorkshopTab.vue'
import ProgrammaticTab from './ProgrammaticTab.vue'
import TopicTab from './TopicTab.vue'
import ColdTopicTab from './ColdTopicTab.vue'
import OtherWorkshopTab from './OtherWorkshopTab.vue'
import { mapGetters } from 'vuex'
import mixin from '@/utils/mixin.js'
import CustomDynamicStaticContentPage from '@/components/Dynamic/CustomDynamicStaticContentPage.vue'
import CriticalIssueWorkshopTab from './CriticalIssueWorkshopTab.vue'
import ScientificActivitiesCustomStaticContent from '@/components/Dynamic/ScientificActivitiesCustomStaticContent.vue'

export default {
  name: 'Workshops',
  components: {  CurrentAndUpcomingWorkshopTab, PastWorkshopTab, ProgrammaticTab, CustomDynamicStaticContentPage, TopicTab, ColdTopicTab, OtherWorkshopTab, CriticalIssueWorkshopTab, ScientificActivitiesCustomStaticContent },
  props: ['workshopType'],
  data () {
    return {
      workshopFeatureData: {},
      loadingWorkshopData: true,
      tabs: ['#current_upcoming_workshop', '#past_workshop', '#programmatic_workshop', '#hot_topics_workshop', '#critical_issues_workshop', '#other_workshop'],
      newContents: [],
      menuId: '',
    }
  },
  mixins: [mixin],
  mounted() {
    if(this.tabs.indexOf(this.$route.hash) !== -1) {
      var hashPath = this.$route.hash
      this.setCurrentTab(hashPath.substring(1), 'workshop-tab-id')
    }
  },
  computed: {
    ...mapGetters(['getActiveTab'])
  },
  created () {
    this.loadWorkshopData()
  },
  methods: {
    loadWorkshopData () {
      this.$http.get(process.env.VUE_APP_API_URL + `/msri_menus/show_page_contents`, {
        params: {
          menu_path: this.$route.path
        }
      })
      .then((res) => {
        if(Object.keys(res.data).length !== 0) {
          var result = {};
          res.data.results.forEach((prop,index) => {
            result[prop.field_name] = prop;
          });
          this.menuId = res.data.id
          this.workshopFeatureData = result
          this.newContents = res.data.new_contents
          this.loadingWorkshopData = false
        } else {
          this.$toasted.global.error('There are no details available for this page. Please check back.')
        }
      })
    }
  }
}
</script>
